const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/components/KisimObjIcon/store/actions.ts';
import { KISAPI as API } from '../../../middleware/kisapi';
import { KisApiAction, kisapiActionTypes } from '../../../defs/actionTypes';
import { apiLoadMetaKatChildren, apiLoadMetaKatRecordByKatFkey } from '@cistec/common_web/actions/kisapi/metaKat';

/**
 * Root node where to find the configuration in MetaKat
 */
const KISIM_OBJICON_CONFIG_PCODE = '1f396e6e-9571-4b09-80ce-7dfd6e15e26c';

/**
 * Action types
 */
export const actionTypes = {
    loadIconTypes: kisapiActionTypes('COMMON_WEB_LOAD_ICON_TYPES'),
    loadObjIcon: kisapiActionTypes('COMMON_WEB_LOAD_OBJ_ICON'),
};

/**
 * Action to load the root nodes of the icon configuration.
 * @param callerId Optional identifier that may be used to identify the action via meta from sagas, etc.
 */
export function loadIconTypes(callerId?: string) {
    const fields = ['ICODE', 'KAT', 'FKEY', 'STATUS'];
    return {
        type: actionTypes.loadIconTypes.combined,
        [API]: apiLoadMetaKatChildren(KISIM_OBJICON_CONFIG_PCODE, fields, true),
        meta: { fields, callerId },
    };
}

export type ILoadIconTypesAction = KisApiAction<typeof loadIconTypes>;

/**
 * Action to look for an icon configured for a particular object type as specified by the given metaKatFkey
 * @param pcode MetaKat parent icode
 * @param metaKatFkey FKEY of child
 * @param callerId May be used to identify action via meta
 */
export function loadObjIcon(pcode: string, metaKatFkey: string, callerId?: string) {
    const fields = ['KAT', 'FKEY', 'NAME', 'STATUS'];

    if (!metaKatFkey) {
        throw Error('loadObjIcon: Missing required field: metaKatFkey');
    }

    return {
        type: actionTypes.loadObjIcon.combined,
        [API]: apiLoadMetaKatRecordByKatFkey(pcode, 'IconDefs', metaKatFkey, false, false, true, fields),
        meta: {
            pcode,
            metaKatFkey,
            fields,
            suppressErrorMsg: true, // no snackbar when icon cannot be found
            callerId,
        },
    };
}

export type ILoadObjIconAction = KisApiAction<typeof loadObjIcon>;
